import { FooterButtonStoryblok, LinkGroupStoryblok, LinkStoryblok } from '@/types/types-storyblok';

export const isSelectedSection = (pathName: string, linkGroup: LinkGroupStoryblok): boolean => {
  return linkGroup.links.some(link => isSelectedLink(pathName, link as LinkStoryblok));
};

export const isSelectedLink = (pathName: string, link: LinkStoryblok | FooterButtonStoryblok): boolean => {
  return link.component !== 'footerButton' && link.link?.url && link.link.url === pathName;
};
